import {Inject, Injectable} from "@angular/core";
import * as _ from 'lodash';
import { ActionBarConfig } from 'src/shared/model/action-bar-config';
import { ActionBarType } from 'src/shared/constants/action-bar-type.enum';
import { ActionBarBehavior } from './action-bar-behavior';

@Injectable()
export class ActionBarContext {

  constructor(
    @Inject(ActionBarBehavior) private strategies: ActionBarBehavior[]
  ) {
  }

  execute(actionBarConfig: ActionBarConfig, type: ActionBarType, selectedRecords?: any[], additionalParams?: any) {
    const strategy = _.find(this.strategies, (strategy) => {
      return strategy.isActionBar(type);
    });

    if (strategy === undefined) {
      return null;
    }
    return strategy.executeAction(actionBarConfig, selectedRecords, additionalParams);
  }
}
